export default {
  BusinessPurchaseEntryComPage: {
    header: {
      code: 'Inbound Notification Number',
      queryCode: 'Inbound Result Number',
      supplier: 'Supplier',
      supplierText: 'Supplier Code/Name',
      type: 'Inbound order type',
      warehouseCode: 'Receiving Warehouse',
      purchaseCode: 'Purchase Order No.',
      spuCode: 'Product Code',
      skuCode: 'SKU',
      startData: 'Start Date',
      endData: 'End dDte',
      reviewTime: 'Review time',
      storageTime: 'Inbound Time',
    },
    sapBtn: 'PUSH SAP',
    errMsg1: "You can only push orders with an 'SAP push failed' status into the warehouse.",
    pushSap: 'Manual push to SAP',
    addOrder: 'Add Inbound order',
    review: 'Review',
    antiAudit: 'Anti audit',
    confirmStorage: 'Confirm Inbound',
    export: 'Export',
    errorText: 'There are documents with incorrect status, unable to perform current operation.',
    msgError: 'The current status is not editable.',
    msgError2: 'The selected purchase order status does not meet the push conditions, please choose again!',
    msgBox1: 'Whether',
    msgBox2: 'Selected Document',
    msgBox3: 'Do you want to cancel the selected documents?',
    msgBox4: 'Please confirm the inbound, the operation cannot be reversed.',
    downName1: 'Purchase Inbound Notification Export',
    downName2: 'Purchase Inbound Result Export',
    code: 'Warehouse Receipt Number',
    applyCode: 'Associated Purchase Request Number',
    warehouseTitle: 'Warehouse Receipt Confirmation',
    outPutPdfFn: 'Warehouse Receipt PDF',
    outPutExcel: 'Warehouse Receipt Excel',
    auOutPutPdfFn: 'Australian Purchase Warehouse Receipt Details PDF',
    planQty: 'Quantity Pending Receipt',
    alreadyQty: 'Quantity Received in This Shipment',

    table: {
      supplierName: 'Inventory Type',
      typeMeaning: 'Storage type',
      purchaseCode: 'Purchase Order No.',
      auditDate: 'Last revision time',
      stockinDate: 'Inbound Time',
      warehouseName: 'Receiving Warehouse',
      planQty: 'Document Quantity',
      alreadyQty: 'Actual Quantity',
      waitQty: 'Unreceived Quantity',
      logisticsBusinessName: 'Logistics Company',
      logisticsNo: 'Waybill Number',
      remark: 'Remark',
      lastUpdateDate: 'Last Modification Time',
      sourceMeaning: 'Source'
    }
  },
  BusinessPurchaseEntryComView: {
    purchase: 'Purchase Receipt',
    statusText: 'Document Status',
    operationLog: 'Operation Log',
    statusMeaning: 'Inbound Receipt Status',
    inform: 'Document Quantity',
    alreadyQty: 'Inbound Quantity',
    waitQty: 'Uninbound Quantity',
    informationText: 'Order Account Information',
    code: 'Purchase Inbound Notification Number',
    resultCode: 'Purchase Inbound Result Number',
    typeMeaning: 'Inventory Type',
    supplierName: 'Supplier',
    warehouseName: 'Receiving Warehouse',
    purchaseCode: 'Purchase Order No.',
    auditDate: 'Review time',
    stockinDate: 'Inbound Time',
    logisticsBusinessName: 'Logistics Company',
    logisticsNo: 'Waybill Number',
    recipientName: 'Full Name',
    phone: 'Mobile',
    address: 'Delivery Address',
    notify: 'Notification',
    result: 'Result',
    log: ' Log',
    one: ' Order',

    table: {
      title: 'Purchase Receipt Product Information',
      spuPic: 'Product Image',
      spuCode: 'Product Code',
      spuName: 'Product Name',
      skuCode: 'SKU',
      skuName: 'SKU Name',
      planQty: 'Document Quantity',
      alreadyQty: 'Actual Inbound Quantity',
      waitQty: 'Uninbound Quantity',
      taxUnitPrice: 'The unit price including tax',
      taxRate: 'Tax Rate',
      taxPrice: 'Tax-Inclusive Amount',
      supplierSpuCode: 'Supplier Product Code',
      supplierSkuCode: 'Supplier SKU Code',
      remark: 'Product Remarks'
    }
  }
};
